import TabApp from './src/tab-app';

export default TabApp;
